import { z } from 'zod';

/** The customer onboarding form's rules: the five identifiers are required, the rest is optional. */
export const onboardSchema = z.object({
  customerMoniker: z.string().min(1, 'Customer moniker is required'),
  customerName: z.string().min(1, 'Customer name is required'),
  customerDbSubdomain: z.string().min(1, 'Customer DB subdomain is required'),
  clientBayDomain: z.string().min(1, 'ClientBAY domain is required'),
  sitesBayDomain: z.string().min(1, 'SitesBAY domain is required'),
});
